import Layout from '@/views/layout/App'

export default {
    path: '/classification',
    meta: {
        title: '教研管理',
        keepAlive: false
    },
    component: Layout,
    redirect: '/classification/',
    children: [{
            path: '/',
            name: 'classification',
            meta: {
                title: '分类设置',
                keepAlive: false
            },
            component: resolve => require(['@/views/classification/index.vue'], resolve),
        },
    ]
}
